<template lang="pug">
  div(v-if="(processoArquivado() && showDesarquivamentoCard) && $route.name === 'gerenciamento-daes'").card-info
    el-row
      div.d-flex.tb
        div.column
          p.verde-text Seu processo está arquivado
          p.verde-text Clique no botão ao lado para desarquivá-lo. Ao clicar, será gerado um DAE de desarquivamento, após o pagamento o processo desarquivará de forma automática.
        div.botao
          el-button.green.textButtonBreak(
            tipo="success",
            @click="consultarBoleto()"
          )
            span.center
              i.fal.fa-credit-card &nbsp
                span Desarquivar Processo
</template>
<script>
import { mapActions } from 'vuex'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
export default {
  data () {
    return {
      processo: null,
      isMonitoramento: null,
      idProcesso: ''
    }
  },
  mixins: [
    AppNotificacao
  ],
  async mounted () {
    this.reloadProcesso()
  },

  computed: {
    showDesarquivamentoCard () {
      return this.isMonitoramento
    }
  },

  methods: {
    ...mapActions({
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      findDaes: 'dae/findDaesByNumeroProcesso'
    }),
    async reloadProcesso () {
      await this.getProcessoByProtocolo(this.$route.params.idCadastro).then((r) => {
        this.processo = r
        this.idProcesso = this.processo.id
      })
      this.checaProcessoBloqueadoPorMonitoramento()
    },
    consultarBoleto () {
      const protocolo = this.processo.numeroProtocolo
      axios({ method: 'get', url: `processo/desarquivar/custoBoleto/${protocolo}`, loaderText: 'Calculando valor do boleto...' }).then(
        async (response) => {
          if (this.processo.nomeRazaoSocialInteressado.length > 100) {
            this.confimBoxWithInput(
              `<span style="font-size: 1rem;">Será gerado um boleto no valor de <b>R$${response}</b>.</span> <br /><br />
              <span style="font-size: 0.8rem;">O nome do interessado excede o limite de 100 caracteres permitidos na geração do boleto. <br />
              Por favor, insira abaixo um nome para ser utilizado no boleto:</span>`,
              'Pedido de Desarquivamento',
              ({ value }) => {
                if (value) {
                  this.gerarBoleto({valor: response, nome: value})
                } else {
                  this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'É necessário digitar o nome')
                }
              },
              () => {},
              undefined,
              undefined,
              undefined,
              /^.{1,149}$/,
              'É necessário um nome de até 150 caracteres')
          } else {
            this.confirmBox(`Será gerado um boleto no valor de R$${response}`, 'Pedido de Desarquivamento', () => { this.gerarBoleto({valor: response}) })
          }
        }
      )
    },

    async checaProcessoBloqueadoPorMonitoramento () {
      const response = await axios({ method: 'get', url: `processo/verificaProcessoArquivadoMonitoramento/${this.idProcesso}` })
      this.isMonitoramento = response
    },

    async gerarBoleto ({valor, nome = ''}) {
      const id = this.processo.id
      const data = {
        boleto: true,
        mensagem: '',
        valorTotal: valor,
        nome
      }
      try {
        await axios({ method: 'post', url: `processo/gerarBoletoDesarquivamento/${id}`, data: data }).then(
          (response) => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Boleto Gerado')
            this.reloadProcesso()
            this.$emit('reload')
          }
        )
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, error)
        this.$emit('reload')
      }
    },

    processoArquivado () {
      return this.processo?.status === 'ARQUIVADO'
    }
  }
}
</script>
<style scoped lang="scss">
.card-info {
  border-radius: 15px;
  background-color: #fff;
  border: solid 1px #009d64;
  margin: 2%;
  margin-bottom: -10px;
}

.d-flex {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tb {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}

.verde-text {
  color: #009d64 !important;
  font-size: 1rem;
}

.green {
  color: #ffffff;
  background-color: #009f61;
  height: 40px;
}

.textButtonBreak {
  white-space: break-spaces;
}

.text-between {
 flex-direction: column;
}

.center {
  display: flex;
  align-items: center;
}

.botao{
  justify-content: flex-end;
}

.column {
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppAvisoDesarquivamento.vue